import React from 'react';
import { logger } from '../utils/logger';

/**
 * 错误边界组件
 * 捕获子组件树中的 JavaScript 错误，并显示备用 UI
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    // 更新 state 使下一次渲染显示备用 UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // 记录错误信息到日志服务
    logger.error('ErrorBoundary caught an error:', error, errorInfo);
    
    // 可以在这里发送错误报告到监控服务
    // sendErrorReport(error, errorInfo);
    
    this.setState({
      error,
      errorInfo
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      // 你可以渲染任何自定义的备用 UI
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--bg-base)',
          color: 'var(--t1)',
          padding: '20px'
        }}>
          <div className="empty" style={{
            maxWidth: '500px',
            textAlign: 'center'
          }}>
            <div className="empty-icon" style={{ fontSize: '64px' }}>⚠️</div>
            <h2 style={{ 
              fontSize: '24px', 
              fontWeight: '700', 
              marginBottom: '16px',
              color: 'var(--t1)'
            }}>
              出现错误
            </h2>
            <p style={{ 
              fontSize: '14px', 
              color: 'var(--t2)',
              marginBottom: '24px',
              lineHeight: '1.6'
            }}>
              {this.state.error?.message || '应用程序遇到未知错误'}
            </p>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div style={{
                background: 'var(--bg-card)',
                border: '1px solid var(--border)',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '24px',
                textAlign: 'left',
                fontSize: '12px',
                fontFamily: 'monospace',
                color: 'var(--red)',
                maxHeight: '200px',
                overflow: 'auto'
              }}>
                <div style={{ fontWeight: '600', marginBottom: '8px' }}>错误详情：</div>
                {this.state.error.stack || this.state.error.toString()}
              </div>
            )}
            
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button 
                className="btn btn-primary"
                onClick={this.handleReload}
              >
                🔄 刷新页面
              </button>
              <button 
                className="btn btn-default"
                onClick={this.handleGoHome}
              >
                🏠 返回首页
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
